import clsx from 'clsx';

interface FlyerLandscapeDoubleSidedProps {
  className?: string;
}

import './Presets.scss';

const FlyerLandscapeDoubleSided: React.FC<FlyerLandscapeDoubleSidedProps> = ({ className }) => {
	return (
		<svg
			className={clsx('flyer-landscape-double-sided', className)}
			fill="none"
			height="120"
			viewBox="0 0 148 120"
			width="148"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 0.5H140C144.142 0.5 147.5 3.85786 147.5 8V108C147.5 112.142 144.142 115.5 140 115.5H12C7.85787 115.5 4.5 112.142 4.5 108V8L4.50977 7.61426C4.71053 3.65139 7.98724 0.5 12 0.5Z"
				fill="white"
			/>
			<path
				d="M12 0.5H140C144.142 0.5 147.5 3.85786 147.5 8V108C147.5 112.142 144.142 115.5 140 115.5H12C7.85787 115.5 4.5 112.142 4.5 108V8L4.50977 7.61426C4.71053 3.65139 7.98724 0.5 12 0.5Z"
				stroke="#D1D2D4"
			/>
			<path
				d="M8 4.5H136C140.142 4.5 143.5 7.85786 143.5 12V112C143.5 116.142 140.142 119.5 136 119.5H8C3.85787 119.5 0.5 116.142 0.5 112V12L0.509766 11.6143C0.710535 7.65139 3.98724 4.5 8 4.5Z"
				fill="white"
			/>
			<path
				d="M8 4.5H136C140.142 4.5 143.5 7.85786 143.5 12V112C143.5 116.142 140.142 119.5 136 119.5H8C3.85787 119.5 0.5 116.142 0.5 112V12L0.509766 11.6143C0.710535 7.65139 3.98724 4.5 8 4.5Z"
				stroke="#D1D2D4"
			/>
			<rect fill="#D1E7DD" height="100" width="128" x="8" y="12" />
			<path
				d="M84 68.5L84 58C84 56.3431 82.6569 55 81 55C81 53.3431 79.6569 52 78 52L63 52C61.3431 52 60 53.3431 60 55L60 65.5C60 67.1569 61.3431 68.5 63 68.5C63 70.1569 64.3431 71.5 66 71.5L81 71.5C82.6569 71.5 84 70.1569 84 68.5ZM64.5 68.5L78 68.5C79.6569 68.5 81 67.1569 81 65.5L81 56.5C81.8284 56.5 82.5 57.1716 82.5 58L82.5 68.5C82.5 69.3284 81.8284 70 81 70L66 70C65.1716 70 64.5 69.3284 64.5 68.5ZM78 53.5C78.8284 53.5 79.5 54.1716 79.5 55L79.5 65.5C79.5 66.3284 78.8284 67 78 67L63 67C62.1716 67 61.5 66.3284 61.5 65.5L61.5 55C61.5 54.1716 62.1716 53.5 63 53.5L78 53.5Z"
				fill="#75B798"
			/>
		</svg>
	);
};


export default FlyerLandscapeDoubleSided;
